{
  "version": 1,
  "asset_id": "69e64567-0f5c-4c84-be24-0157a68334c8",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/69e64567-0f5c-4c84-be24-0157a68334c8/beverly-hills-shingle-roof-underlayment-1280w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/69e64567-0f5c-4c84-be24-0157a68334c8/beverly-hills-shingle-roof-underlayment-1280w.webp",
  "original_filename": "beverly-hills-shingle-roof-underlayment-1280w.webp",
  "size": 207904,
  "content_type": "image/webp",
  "created_at": "2026-07-29T14:07:23Z"
}
